import { BehaviorSubject, Observable } from 'rxjs';

import { ApiVersions } from 'src/app/shared/services/api-version';
import { FileItem } from 'ng2-file-upload';
import { BaseService } from 'src/app/shared/services/base.service';
import { DocumentScanEvent } from '../models/documentScanEvent';
import { DocumentScanStatusType } from '../models/documentScanStatusType';
import { buildFileUploadData } from '../components/document-upload/document-upload.helper';

export class UploadBaseService extends BaseService {
  public readonly virusScanResult = new BehaviorSubject<DocumentScanEvent>({
    status: DocumentScanStatusType.Started,
    documentPassedScan: false,
  });

  protected doUpload(
    endpoint: string,
    file: FileItem | File,
    showMessage: boolean,
    apiVersion: ApiVersions,
    onComplete?: () => {}
  ): Observable<any> {
    const formData = buildFileUploadData(file);
    let obs = this.post(endpoint, formData, {}, apiVersion);

    obs.subscribe((result) => {
      if (result) {
        // If we end up allowing multi-uploads -- this will need to be revisited
        if (result instanceof Array) {
          result.forEach((responseMessage) => {
            this.responseToResult(showMessage, responseMessage, onComplete);
          });
        } else {
          this.responseToResult(showMessage, result, onComplete);
        }
      }
    });

    return obs;
  }

  protected doScan(
    endpoint: string,
    file: FileItem | File,
    showMessage: boolean,
    apiVersion: ApiVersions
  ) {
    const formData = buildFileUploadData(file);
    let obs = this.post(endpoint, formData, {}, apiVersion);

    obs.subscribe((result: any) => {
      let defaultErrorMessage = 'Virus scan failed. Please try uploading the document again.';
      if (result) {
        // If we end up allowing multi-uploads -- this will need to be revisited
        if (result instanceof Array) {
          if (result.find((x) => x.success == false)) {
            this.virusScanResult.next({
              status: DocumentScanStatusType.Finished,
              documentPassedScan: false,
              errorMessage:
                result && result.length > 0 && result[0].message
                  ? result[0].message
                  : defaultErrorMessage,
            });
          } else {
            this.virusScanResult.next({
              status: DocumentScanStatusType.Finished,
              documentPassedScan: true,
            });
          }
        } else {
          this.virusScanResult.next({
            status: DocumentScanStatusType.Finished,
            documentPassedScan: result.success,
            errorMessage: result && result.message ? result.message : defaultErrorMessage,
          });
        }
      } else {
        this.virusScanResult.next({
          status: DocumentScanStatusType.RequestFailed,
          documentPassedScan: false,
          errorMessage: defaultErrorMessage,
        });
      }
    });

    return obs;
  }

  private responseToResult(showMessage: boolean, responseMessage: any, onComplete: () => {}) {
    if (showMessage) {
      this.openSnackBar(responseMessage.message, responseMessage.success);
    }
    if (onComplete) {
      onComplete();
    }
  }
}
